"use client"

import { useEffect, useState } from "react"
import { useAuthStore } from "@/hooks/use-auth"
import { useSessionIdleTimeout } from "@/hooks/use-session-idle-timeout"

export function AuthProvider({ children }: { children: React.ReactNode }) {
  const [isInitialized, setIsInitialized] = useState(false)
  const validateSession = useAuthStore((s) => s.validateSession)
  const tokens = useAuthStore((s) => s.tokens)

  useSessionIdleTimeout()

  useEffect(() => {
    async function initAuth() {
      if (tokens?.access_token) {
        await validateSession()
      }
      setIsInitialized(true)
    }

    initAuth()
  }, [tokens?.access_token, validateSession])

  if (!isInitialized) {
    return null
  }

  return <>{children}</>
}
